window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');

window.Hogan = require("hogan.js");; // for plugins/scheduler/scheduler
require('bootstrap');
window.ApexCharts = require('apexcharts');
// require('./scrollbar');
// window.beautify = require('./beautify');
window.Swal = require('sweetalert2/dist/sweetalert2.js');
// window.feather = require('feather-icons');
// window.toastr = require('toastr');

window.beautify = require('./beautify');
window.mdtimepicker = require('@dmuy/timepicker');
moment = require('moment')
require('bootstrap4-toggle');
require('bootstrap-datepicker');
require('bootstrap-daterangepicker');
require('select2');
require('summernote/dist/summernote-bs4.min.js');
require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-buttons');
require('datatables.net-buttons-bs4');


require('block-ui');


// const JSZip = require('jszip');
// const pdfMake = require('pdfmake');
require( 'datatables.net-buttons/js/buttons.html5.js' );
// require( 'datatables.net-buttons/js/buttons.print.js' );

// require('./uploader');
require('../vendor/dropzone/dropzone');
// require('jquery.qrcode');

require('./ajax');
require('./functions');
// require('./rating');
require('./div-radio');

window.intlTelInput = require("intl-tel-input");
require("intl-tel-input/build/css/intlTelInput.css");

var _sortable = require('sortablejs');
window.Sortable = _sortable.default || _sortable;

require('./plugins/scheduler/scheduler');
require('./plugins/file-dropzone');
require('./notifications-handler');
require('./initializer');
require('./search');
// require('./stripe-init');
// require('./address-picker');
// require('./order-wizard');
